import { UseControllerProps } from 'react-hook-form';

export const ADDRESS_RULE: UseControllerProps['rules'] = {
  pattern: {
    value: /^[\u0600-\u06FF\s\d\-–.]+$/,
    message: 'حروف انگلیسی مجاز نیست.',
  },
};
